export default __webpack_public_path__ + "e41a343a2d34df2945c988427996d312.svg";